module.exports = __webpack_public_path__ + "img/3.3e2aa1b4.png";